import React, { useEffect, useState } from "react";
import "./terms-privacy.css";
import Header from "../../Components/Header/Header";

const PrivacyPolicy = () => {
  const [data, setData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://prod-api.astrocure.co.in/api/v1/settings/terms_privacy",
        );
        const result = await response.json();
        setData(result.data);
      } catch (error) {
        console.error("Error fetching privacy policy:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <div className="topDiv">
      <Header />
      <div className="empty" />
      <div className="terms-privacy ql-editor">
        <div
          style={{ marginBottom: "2rem" }}
          dangerouslySetInnerHTML={{ __html: data?.privacyPolicy }}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
